import type {CrudFilters} from '@refinedev/core';

export const generateFilter = (filters?: CrudFilters) => {
  const queryFilters: {[key: string]: string} = {};

  if (filters) {
    filters.map((filter) => {
      if (filter.operator === 'or' || filter.operator === 'and') {
        throw new Error(
          `[@refinedev/simple-rest]: \`operator: ${filter.operator}\` is not supported. You can create custom data provider. https://refine.dev/docs/api-reference/core/providers/data-provider/#creating-a-data-provider`,
        );
      }

      if ('field' in filter) {
        const {field, operator, value} = filter;
        queryFilters['_field'] = field;

        if (operator === 'contains') {
          queryFilters['_value'] = `*${value}*`;
        } else {
          queryFilters['_value'] = value;
        }
      }
    });
  }

  return queryFilters;
};
